export default __webpack_public_path__ + "static/media/Low Fidelity Image.f5924cb3.svg";